import { PublicLayout } from '~/components/layout';
import CenteredInfoLayout from '~/components/layout/templates/CenteredInfo.tsx';
import Box from '~/components/new/Box.tsx';
import { ButtonLink } from '~/components/new/Button.tsx';
import storage from '~/utils/storage.ts';

export default function ErrorPage() {
    const returnTo = storage.getItem('return_to');
    return (
        <PublicLayout hideButtons>
            <CenteredInfoLayout verticallyAligned>
                <Box>
                    <p>Unusual activity has been detected from your device</p>
                    <p>Please try again later.</p>
                    {returnTo && (
                        <div className='text-center'>
                            <p>
                                <ButtonLink to={returnTo}>Go back</ButtonLink>
                            </p>
                        </div>
                    )}
                </Box>
            </CenteredInfoLayout>
        </PublicLayout>
    );
}
